import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MerchantSetupResponseModel } from './merchantSetupResponseModel';
import { SetupPasswordRequestModel } from './setupPasswordRequestModel';

@Injectable({
  providedIn: 'root',
})
export class SetupService {
  constructor(private http: HttpClient) {}

  searchCard(merchantId: string): Observable<MerchantSetupResponseModel> {
    return this.http.get<MerchantSetupResponseModel>(
      `/v2/merchant/setup/${merchantId}`
    );
  }

  setInitialPinAndEmail(
    merchantId: string,
    password: string,
    email: string
  ): Observable<MerchantSetupResponseModel> {
    return this.http.post<MerchantSetupResponseModel>(
      `/v2/merchant/setup/${merchantId}`,
      {
        password,
        email,
      } as SetupPasswordRequestModel
    );
  }

  migrateToEmail(
    merchantId: string,
    password: string,
    email: string
  ): Observable<MerchantSetupResponseModel> {
    return this.http.post<MerchantSetupResponseModel>(
      `/v2/merchant/setup/migrate/${merchantId}/v2`,
      {
        password,
        email,
      } as SetupPasswordRequestModel
    );
  }
}
